import Vue from 'vue'
// Components
Vue.component('Top', require('@/components/Top.vue').default)
Vue.component(
  'BtnWhatsapp',
  require('@/components/social/BtnWhatsapp.vue').default
)

const pages = [
  // layout
  ['layout', './layout/Index.vue'],
  // Páginas
  ['Home', './Home.vue'],
  ['Contato', './Contato.vue'],
  ['Local', './Localizacao.vue'],
  // Módulos
  ['Services', './modules/Services.vue'],
  ['Members', './modules/Members.vue'],
  ['Clientes', './modules/Clientes.vue'],
  ['Horario', './Horario.vue']
]

pages.filter((r) => {
  Vue.component(`${r[0]}`, require(`${r[1]}`).default)
})
